import React, { useState, useEffect } from "react";
import Loader from "components/Loader";
import { useParams } from "react-router-dom";
import TimelinePostList from "components/TimelinePostList";
import TeamService from "services/TeamService";
import { TimelineContext } from "store/contexts/timelineContext";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as timelineActions from "reteamStore/actions";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useGlobalContext } from "store/contexts/globalContext";

const styles = {
  heading: {
    fontWeight: 400,
    display: "flex",
    justifyContent: "center",
    marginBottom: "0px",
    paddingTop: "30px",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
};

export default () => {
  const classes = styles;
  let history = useHistory();
  const dispatch = useDispatch();
  const { post } = useSelector((state) => state.timelineReducer);
  const { postId } = useParams();
  const { teamId } = useTeamActionContext();
  const [total, setTotal] = useState("");
  const [loading, setLoading] = useState(true);
  const { ringCentral } = useGlobalContext();
  const [post_types] = useState({
    celebration: "Celebration",
    brightidea: "Bright Idea",
    text: "Status",
    checkin: "Check In",
    slideshow: "Slideshow",
    teamvideo: "TeamVideo",
  });

  const rootStyle = {
    display: " flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  const [post_type, setPostType] = useState(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await TeamService.getSinglePost(teamId, postId);

        dispatch(timelineActions.getSinglePost(response.data.data));

        setPostType(post_types[response.data.data.type]);
        setTotal(1);
      } catch (e) {
        console.log(e);
        setTotal(0);
        if (ringCentral) {
          history.push(`/ringCentral/teams/${teamId}/noPost/post`);
          return;
        }
      }
      setLoading(false);
    })();

    return () => {
      dispatch(timelineActions.clearSinglePost());
    };
    //eslint-disable-next-line
  }, [postId]);

  const updatePost = (newPost) => {
    const postCopy = [...post];

    postCopy[
      postCopy.findIndex((tPost) => {
        return tPost.id === newPost.id;
      })
    ] = {
      ...newPost,
    };

    Promise.all([
      dispatch(timelineActions.updateSinglePost(newPost)),
      dispatch(timelineActions.updatePost(newPost)),
    ]);
  };

  const deletePost = (post) => {
    setTotal("");
    Promise.all([
      dispatch(timelineActions.deletePost(post)),
      dispatch(timelineActions.clearSinglePost()),
    ]);

    history.push(`/teams/${teamId}/timeline`);
  };

  return (
    <TimelineContext.Provider
      value={{
        updatePost,
        deletePost,
      }}
    >
      {loading && (
        <div style={classes.loaderStyle}>
          <Loader />
        </div>
      )}
      {!loading && (
        <div style={rootStyle} className="postContent">
          {post_type && <h3 style={classes.heading}>{post_type} post</h3>}
          <TimelinePostList posts={post} total={total} />
        </div>
      )}
    </TimelineContext.Provider>
  );
};
